<template>
  <div class="line-item">
    <div class="item-title-bar">
      <div class="divider-line divider-line-start"></div>
      <div class="line-item-index">5</div>
      <div class="line-item-name">{{ info.status === 4 ? '审核通过' : '审核' }}</div>
      <div class="box2 btn" v-if="info.status === 3" @click="reject"><i class="iconfont icon-bohui"></i> 驳回</div>
      <div class="box4 btn" v-if="info.status === 3" @click="examine"><i class="iconfont icon-tongguo"></i> 通过</div>
      <div class="divider-line divider-line-center"></div>
      <div class="line-item-time" v-if="info.passTime">
        通过时间: {{ info.passTime }}
        <i class="el-icon-caret-top"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { warningProcess } from "@/api/warning";
export default {
  name: "LineItem", // 审核中状态时
  props: {
    info: { type: Object, default: () => {} }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    reject () {
      const form = {
        id: this.info.id,
        status: this.info.appeal === '0' ? 9 : 4
      }
      warningProcess(form).then(() => {
        this.$emit('refreshInfo')
        this.$bus.emit('refreshWarning')
        this.$message.success('已驳回该事件上报')
      })
    },
    examine () {
      const form = {
        id: this.info.id,
        status: this.info.appeal === '0' ? 4 : 6
      }
      warningProcess(form).then(() => {
        this.$emit('refreshInfo')
        this.$bus.emit('refreshWarning')
        this.$message.success('已审核该事件上报')
      })
    }
  },
};
</script>

<style scoped lang="less">
.line-item {
  .item-title-bar {
    display: flex;
    align-items: center;
    margin-top: 12px;
    .btn{
      width: 140px;
      height: 50px;
      background-size: 100% 100%;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
    }
    .box2{
      background-image: url("../../../../assets/img/box2.png");
      color: #00FFF6;
    }
    .box4{
      background-image: url("../../../../assets/img/box4.png");
      color: #00B2FF;
    }
    .line-item-index {
      position: relative;
      width: 38px;
      height: 31px;
      margin: 0 10px 0 3px;
      font-weight: bold;
      font-style: italic;
      font-size: 20px;
      color: #00b2ff;
      text-align: center;
      line-height: 31px;
      border-radius: 4px;
      box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.5) inset;

      &::after {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(100%, -50%);
        content: "";
        border: 4px solid transparent;
        border-left-color: rgba(0, 178, 255, 0.4);
      }
    }

    .line-item-name {
      margin-right: 6px;
      font-size: 18px;
      color: #ffffff;
    }

    .line-item-time {
      display: flex;
      align-items: center;
      margin-left: 10px;
      font-size: 14px;
      color: #00b2ff;

      .el-icon-caret-top {
        font-size: 22px;
        margin-left: 5px;
      }
    }
  }

  .divider-line {
    border-bottom: 1px dashed #00fff6;

    &.divider-line-start {
      width: 50px;
    }

    &.divider-line-center {
      width: 0;
      flex: auto;
    }
  }

  .line-content {
    display: flex;
    flex-wrap: wrap;
    height: auto;

    .clip-box {
      width: 373px;
      height: 182px;
      margin-top: 20px;
      margin-left: 40px;
    }

    .person-info-wrapper {
      .person-info-box {
        width: 100%;
        height: 100%;
        display: flex;

        .person-img {
          width: 190px;
          height: 100%;
          object-fit: cover;
        }

        .person-info {
          width: 0;
          height: 100%;
          flex: auto;
          padding: 8px 10px;
          box-sizing: border-box;
          color: #FFFFFF;

          .info-item {
            line-height: 26px;
            margin-bottom: 4px;
            .info-item-label {
              color: #00b2ff;
              font-size: 14px;
            }

            .info-item-cell {
              display: flex;
              color: #ffffff;
              font-size: 14px;
              .cell-label {
                width: 52px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
